// extracted by mini-css-extract-plugin
module.exports = {"resultsHeader":"_2BKJ6o","vehicle":"_3tTLvT","vehicleName":"PMhp8F","licenseplate":"_1E0m3U","makeModel":"_1rdb5K","vehicleActions":"VQxQhI"};